import React from "react";
import { Card, Image } from "react-bootstrap";
import { ChevronRight } from "react-bootstrap-icons";
import NavIcon from "@/components/navigation/navIcon";
import type { TIconKey } from "@/types";

interface IMenuBadgeItemProps {
  iconPath?: string | null;
  iconKey?: TIconKey;
  name: string;
  onClick: () => void;
  showNumberSelected?: boolean;
  selectedCount?: number;
}

const MenuBadgeItem: React.FC<IMenuBadgeItemProps> = ({
  iconPath,
  iconKey,
  name,
  onClick,
  selectedCount,
}) => {
  return (
    <Card
      className="card-menu border-0 bg-violet-bg rounded-3 rounded-md-4 p-0"
      as="button"
      onClick={onClick}
    >
      <Card.Body className="d-flex align-items-center justify-content-between p-4 p-md-8">
        <div className="d-flex align-items-center gap-2 gap-md-4">
          {iconPath ? (
            <div className="d-flex align-items-center justify-content-center">
              <Image
                src={iconPath}
                alt={name}
                width={20}
                height={20}
                className="object-fit-contain category-heading-icon"
              />
            </div>
          ) : null}
          <div className="d-flex align-items-center justify-content-center">
            {iconKey ? <NavIcon iconKey={iconKey} variant="desktop" /> : null}
          </div>
          <div className="menu-badge-item-fs text-text-primary lh-sm">
            {name}
          </div>
        </div>
        <div className="d-flex align-items-center">
          {typeof selectedCount === "number" ? (
            <span className="fs-16 fw-bold me-2">{selectedCount ?? 0}</span>
          ) : null}
          <ChevronRight className="text-primary" />
        </div>
      </Card.Body>
    </Card>
  );
};

export default MenuBadgeItem;
